export const CwShellLeftNavExpand = {
  COLLAPSED: 'Collapsed',
  DEFAULT: 'Default',
  FAT: 'Fat'
};


// WEBPACK FOOTER //
// ./src/components/cwshellleftnav/constants.js